<ui-modal [modalTitle]="'Edit Times'" size="md">
	<div *ngIf="list">
		<div class="d-flex">
			<h4 class="text-uppercase">{{dateString | localizedDate:'EEE'}} {{dateString | mySQLDateToISO | localizedDate:'shortDate'}}</h4>
			<span *ngIf="hasConflict" class="text-primary"><i class="wq wq-info ml-2 mr-1"></i> There are time conflicts</span>
		</div>
		<hr class="mt-0">

		<div *ngIf="list.length" class="conflict-list" style="max-height: 570px; overflow: auto;">
			<ui-form>
				<div *ngFor="let entry of list" class="border p-2 mr-2 border-2 mb-4">
					<div class="mb-1 text-danger text-bold text-large">{{entry.project_description}}</div>
					<div class="d-flex align-items-center">
						<div class="ml-2">
							<div class="text-secondary">Job: {{entry.work_order_no}}</div>
							<div class="text-bold" *ngIf="entry.type === 'travel'">
								<i class="wq wq-truck-fill text-info mx-1"></i>Travel
							</div>
							<div *ngIf="entry.type ==='task'">
								<span class="text-lines lines-1 text-bold" style="max-width: 18rem;" uiEllipsisTooltip>Task: {{entry.task_name}}</span>
							</div>
							<div *ngIf="entry.needs_approval" class="text-info text-small mt-1 text-bold">Needs Approval</div>
						</div>
						<div class="flex-weight-1"></div>
						<div class="mr-2">
							<div>
								<div class="d-flex align-items-center my-n2 item">
									<ui-form-control>
										<p-calendar [(ngModel)]="entry.start_time" (ngModelChange)="validateConflicts()" [ngModelOptions]="{ standalone: true }" [timeOnly]="true" [hourFormat]="app.calendarHourFormat" [inputStyleClass]="entry.isConflict ? 'form-control w-6r conflict' : 'form-control w-6r'" appendTo="body"></p-calendar>
									</ui-form-control>
									<span><i class="wq wq-arrow-alt-right mx-2"></i></span>
									<ui-form-control>
										<p-calendar [(ngModel)]="entry.end_time" (ngModelChange)="validateConflicts()" [ngModelOptions]="{ standalone: true }" [timeOnly]="true" [hourFormat]="app.calendarHourFormat" [inputStyleClass]="entry.isConflict ? 'form-control w-6r conflict' : 'form-control w-6r'" appendTo="body"></p-calendar>
									</ui-form-control>
									<div class="d-flex">
										<i class="wq wq-delete mx-1 px-2 py-1 selectable text-secondary" (click)="delete(entry, null, false)"></i>
									</div>
								</div>
								<div *ngIf="entry.isConflict" class="mt-n2 text-center text-primary text-uppercase text-bold">{{conflictMessage(entry)}}</div>
							</div>
						</div>
					</div>
					<ng-container *ngIf="entry.breaks && entry.breaks.length">
						<hr class="mx-2">
						<div class="ml-2">
							<div class="text-warning mb-1"><i class="wq wq-coffee mr-1"></i>Breaks</div>
							<div *ngFor="let break of entry.breaks; let i = index;" class="d-flex align-items-center">
								<div class="d-flex align-items-center mt-n2">
									<div>
										<div class="text-bold">Break {{ i + 1 }}</div>
										<div>
											<span *ngIf="break.needs_approval" class="text-info text-small mt-1 text-bold">
												Needs Approval
											</span>
										</div>
									</div>
								</div>
								<div class="flex-weight-1"></div>
								<div class="d-flex align-items-center mr-4">
									<div class="text-secondary mr-2 text-small">{{calculateTimeDifference(break.start_time, break.end_time) || 0 | hours}}</div>
									<div>
										<div class="d-flex align-items-center my-n2 item">
											<ui-form-control>
												<p-calendar [(ngModel)]="break.start_time" (ngModelChange)="validateConflicts()" [ngModelOptions]="{ standalone: true }" [timeOnly]="true" [hourFormat]="app.calendarHourFormat" [inputStyleClass]="break.isConflict ? 'form-control w-6r conflict' : 'form-control w-6r'" appendTo="body"></p-calendar>
											</ui-form-control>
											<span><i class="wq wq-arrow-alt-right mx-2"></i></span>
											<ui-form-control>
												<p-calendar [(ngModel)]="break.end_time" (ngModelChange)="validateConflicts()" [ngModelOptions]="{ standalone: true }" [timeOnly]="true" [hourFormat]="app.calendarHourFormat" [inputStyleClass]="break.isConflict ? 'form-control w-6r conflict' : 'form-control w-6r'" appendTo="body"></p-calendar>
											</ui-form-control>
											<div class="d-flex">
												<i class="wq wq-delete mx-1 px-2 py-1 selectable text-secondary" (click)="delete(entry, break, true)"></i>
											</div>
										</div>
										<div *ngIf="break.isConflict" class="mt-n2 text-center text-primary text-uppercase text-bold">{{conflictMessage(break)}}</div>
									</div>
								</div>
							</div>
						</div>
					</ng-container>
				</div>
			</ui-form>
		</div>

		<div *ngIf="!list?.length" class="w-100 h-100 d-flex align-items-center justify-content-center text-secondary">
			<p>No timesheet entries for the day</p>
		</div>
	</div>
	<div *ngIf="app.orgInfo?.role.manage_teams" class="flex-weight-1 text-info" ui-modal-footer>
		<i class="wq wq-info mr-1"></i> Editing the times would override the approval request(s) if any.
	</div>

	<div *ngIf="!app.orgInfo?.role.manage_teams" class="flex-weight-1 text-danger" ui-modal-footer>
		<i class="wq wq-info mr-1"></i> Editing the times would trigger approval(s) for the entire day.
	</div>

	<button class="btn btn-secondary" (click)="modal.close()" ui-modal-footer>Cancel</button>
	<button class="btn btn-primary" [disabled]="hasConflict || disabled" (click)="save()" ui-modal-footer>Save</button>
</ui-modal>
